import sofiaSansSemiCondensedTtfHref from "../../assets/fonts/SofiaSansSemiCondensed/SofiaSansSemiCondensed-VariableFont_wght.ttf";
import sofiaSansSemiCondensedItalicTtfHref from "../../assets/fonts/SofiaSansSemiCondensed/SofiaSansSemiCondensed-Italic-VariableFont_wght.ttf";
import { preloadFont } from "troika-three-text";

export const Font = {
    SOFIA_SANS_SEMI_CONDENSED: "SofiaSansSemiCondensed",
    SOFIA_SANS_SEMI_CONDENSED_ITALIC: "SofiaSansSemiCondensedItalic",
} as const;
export type Font = (typeof Font)[keyof typeof Font];

export const FONTS: Record<string, string> = {
    [Font.SOFIA_SANS_SEMI_CONDENSED]: sofiaSansSemiCondensedTtfHref,
    [Font.SOFIA_SANS_SEMI_CONDENSED_ITALIC]: sofiaSansSemiCondensedItalicTtfHref,
};

export const DEFAULT_FONT = FONTS.SofiaSansSemiCondensed;

// Eagerly preload all font SDF atlases at module-import time.
// This runs when the Editor page's JS chunk loads — well before the
// renderer initializes — giving troika's web worker enough time to
// build the atlas before the first updateText() call.
//
// SSR-Guard (Phase 12 Step 2): `preloadFont` kickt troika's Web-Worker-
// Setup an, der intern `self` liest — das crasht in vike's SSR-Umgebung
// (Node, kein `self`). Unter SSR überspringen wir den Preload komplett
// und verlassen uns darauf, dass der echte Mount (Browser-only, via
// ClientOnly-Wrapper in public's ViewerChrome) den Atlas just-in-time
// aufbaut. Editor-Chunks laufen weiter im Browser, da ändert sich nichts.
const PRELOAD_CHARS = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZäöüÄÖÜß0123456789.,;:!?-–—()[]{}"\' ';
import fontItalianno from "../../assets/fonts/standard-fonts/Italianno-Regular.ttf";
import fontNotoSans from "../../assets/fonts/standard-fonts/NotoSans-VariableFont.ttf";
import fontNotoSerif from "../../assets/fonts/standard-fonts/NotoSerif-VariableFont.ttf";
if (typeof window !== "undefined") {
    for (const font of Object.values(FONTS)) {
        preloadFont({ font, characters: PRELOAD_CHARS }, () => { /* atlas ready */ });
    }
    for (const font of [fontItalianno, fontNotoSans, fontNotoSerif]) {
        preloadFont({ font, characters: PRELOAD_CHARS }, () => { /* atlas ready */ });
    }
}
